module.exports = __webpack_public_path__ + "img/platform.d09d59fe.png";